import script from './SdsDividerLine.vue_rollup-plugin-vue=script.js';
import normalizeComponent from '../../node_modules/vue-runtime-helpers/dist/normalize-component.mjs.js';
import createInjector from '../../node_modules/vue-runtime-helpers/dist/inject-style/browser.mjs.js';

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sds-divider-line",class:( _obj = {}, _obj[("sds-divider-line--emphasis-" + _vm.emphasis)] = !!_vm.emphasis, _obj['sds-divider-line--dashed'] =  _vm.isDashed, _obj )})};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-a5e0fc10_0", { source: ".sds-divider-line[data-v-a5e0fc10]{--border-style:solid;--border-color:initial;height:1px;border-bottom:1px var(--border-style) var(--border-color)}.sds-divider-line--emphasis-high[data-v-a5e0fc10]{--border-color:var(--system-border-on-elevation-primary)}.sds-divider-line--emphasis-medium[data-v-a5e0fc10]{--border-color:var(--system-border-on-elevation-secondary)}.sds-divider-line--emphasis-low[data-v-a5e0fc10]{--border-color:var(--system-border-on-elevation-tertiary)}.sds-divider-line--dashed[data-v-a5e0fc10]{--border-style:dashed}", map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__ = "data-v-a5e0fc10";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    createInjector,
    undefined,
    undefined
  );

export default __vue_component__;
